import {Route, Routes, useLocation} from "react-router-dom";
import Home from "../../pages/App/App";
import AudiobooksPage from "../../pages/Audiobooks/audiobooks";
import Musics from "../../pages/Musics/Musics";
import VideosPage from "../../pages/Videos/videos";
import Shorts from "../../pages/Shorts/Shorts";
import Error from "../../pages/Error/Error";
import React from "react";
import { AnimatePresence } from 'framer-motion';

const AnimatedRoutes = () => {
    const location = useLocation();

    return (
        <AnimatePresence>
            <Routes location={location} key={location.pathname}>
                <Route exact path="/" element={<Home/>}/>
                <Route path="*" element={<Error/>}/>
                <Route path="/audiobooks" element={<AudiobooksPage/>} />
                <Route path="/musics" element={<Musics/>} />
                <Route path="/videos" element={<VideosPage/>} />
                <Route path="/shorts" element={<Shorts/>} />
            </Routes>
        </AnimatePresence>
    )
}

export default AnimatedRoutes;